import { Component } from '@angular/core';
import { UserAuth, UserForSalesManagement } from 'app/services/sales.service';


export class UserInfoModalComponentViewModel {
  public isOpen: boolean = false;
  
  public user: UserForSalesManagement = new UserForSalesManagement();
  public userAuth: UserAuth = new UserAuth();

  public userModified = {};
  public userAuthModified = {};
  
  public setUser (value: UserForSalesManagement) {
    if (!value) {
      value = new UserForSalesManagement();
    }

    this.user = new UserForSalesManagement(JSON.parse(JSON.stringify(value)));
  } 

  public setUserAuth(value: UserAuth) {
    if (!value) {
      value = new UserAuth();
    }
    this.userAuth = new UserAuth(JSON.parse(JSON.stringify(value)));
  }

  public modifyUser(field: string, value: any) {
    if (!field) {
      return;
    }

    this.userModified[field] = value;
  }

  public modifyUserAuth(field: string, value: any) {
    if (!field) {
      return;
    }

    this.userAuthModified[field] = value;
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/user-info-modal.viewmodel.ts